"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var serializr_1 = require("serializr");
var lodash_1 = require("lodash");
var FeedItem_1 = require("./FeedItem");
var FETCH_FEED_FIELDSET = 'comments,reactions,requesterContext';
var FeedStore = /** @class */ (function () {
    function FeedStore(repository) {
        this.feedItems = [];
        this.loading = false;
        this.cursor = null;
        this.fetch = mobx_1.flow(function () {
            var response, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.repository.feed.list({
                                fieldset: FETCH_FEED_FIELDSET,
                                query: {
                                    limit: 10,
                                },
                            })];
                    case 2:
                        response = _a.sent();
                        this.addFeedItems(response.data.feedItems.map(function (feedItem) { return new FeedItem_1.FeedItem(feedItem, _this.repository); }));
                        this.cursor = response.data.nextPageCursor;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error('FeedStore FeedItems fetch error: ', error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
        this.fetchMore = mobx_1.flow(function () {
            var response, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.cursor) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.repository.feed.list({
                                fieldset: FETCH_FEED_FIELDSET,
                                cursor: {
                                    cursor: this.cursor,
                                    limit: 10,
                                },
                            })];
                    case 2:
                        response = _a.sent();
                        this.addFeedItems(response.data.feedItems.map(function (feedItem) { return new FeedItem_1.FeedItem(feedItem, _this.repository); }));
                        this.cursor = response.data.nextPageCursor || null;
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('FeedStore FeedItems fetch error: ', error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
        this.fetchById = mobx_1.flow(function (feedItemId) {
            var exists, response, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        exists = this.feedItems.some(function (feedItem) { return feedItem.feedItemId === feedItemId; });
                        if (exists) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.repository.feed.get({
                                fieldset: FETCH_FEED_FIELDSET,
                                feedItemId: feedItemId,
                            })];
                    case 1:
                        response = _a.sent();
                        this.addFeedItems([new FeedItem_1.FeedItem(response.data, this.repository)]);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error("FeedStore FeedItems fetch item by id = \"" + feedItemId + " error: ", error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.create = mobx_1.flow(function (entity) {
            var response, error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.feed.create({
                                entity: entity,
                                fieldset: 'comments,requesterContext',
                            })];
                    case 1:
                        response = _a.sent();
                        this.feedItems.unshift(new FeedItem_1.FeedItem(response.data, this.repository));
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error('FeedStore FeedItem create error: ', error_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.update = mobx_1.flow(function (feedItemId, entity) {
            var error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.feed.update({
                                feedItemId: feedItemId,
                                entity: entity,
                                updateMask: {
                                    paths: [
                                        'entity.body',
                                        'entity.mentions',
                                        'entity.attachments',
                                        'entity.externalReferences',
                                    ],
                                },
                            })];
                    case 1:
                        _a.sent();
                        this.fetch();
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error('FeedStore FeedItem update error: ', error_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.delete = mobx_1.flow(function (feedItemId) {
            var index, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        index = this.feedItems.findIndex(function (feedItem) { return feedItem.feedItemId === feedItemId; });
                        if (!(index !== -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.repository.feed.delete(feedItemId)];
                    case 1:
                        _a.sent();
                        this.feedItems.splice(index, 1);
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        console.error('FeedStore FeedItem delete error: ', error_6);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
        this.pin = mobx_1.flow(function (feedItemId) {
            var pinnedFeedItem, error_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        pinnedFeedItem = this.feedItems.find(function (feedItem) { return feedItem.pin; });
                        if (!pinnedFeedItem) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.repository.feed.unpinFromContainer(pinnedFeedItem.feedItemId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.repository.feed.pinToContainer(feedItemId)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.fetch()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_7 = _a.sent();
                        console.error('FeedStore FeedItem pin error: ', error_7);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
        this.unpin = mobx_1.flow(function (feedItemId) {
            var error_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.repository.feed.unpinFromContainer(feedItemId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetch()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.error('FeedStore FeedItem unpin error: ', error_8);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
        this.follow = mobx_1.flow(function (feedItemId) {
            var error_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.repository.feed.subscribeToFeedItem(feedItemId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetch()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        console.error('FeedStore FeedItem follow error: ', error_9);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
        this.unfollow = mobx_1.flow(function (feedItemId) {
            var error_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.repository.feed.unsubscribeFromFeedItem(feedItemId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetch()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        console.error('FeedStore FeedItem unfollow error: ', error_10);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
        /**
         * @deprecated
         * use addReaction
         * */
        this.react = mobx_1.flow(function (feedItemId, reaction) {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.feedItems
                        .find(function (feedItem) { return feedItem.feedItemId === feedItemId; })
                        .react(reaction)];
            });
        });
        /**
         * @deprecated
         * use removeReaction
         * */
        this.unreact = mobx_1.flow(function (feedItemId, reactionCode) {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.feedItems
                        .find(function (feedItem) { return feedItem.feedItemId === feedItemId; })
                        .unreact(reactionCode)];
            });
        });
        this.addReaction = mobx_1.flow(function (feedItemId, userReaction) {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.feedItems
                        .find(function (feedItem) { return feedItem.feedItemId === feedItemId; })
                        .addUserReaction(userReaction)];
            });
        });
        this.removeReaction = mobx_1.flow(function (feedItemId, userReaction) {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.feedItems
                        .find(function (feedItem) { return feedItem.feedItemId === feedItemId; })
                        .removeUserReaction(userReaction)];
            });
        });
        this.comment = mobx_1.flow(function (feedItemId, comment) {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.feedItems
                        .find(function (feedItem) { return feedItem.feedItemId === feedItemId; })
                        .comment(comment)];
            });
        });
        this.repository = repository;
    }
    FeedStore.prototype.sortFeedItems = function () {
        this.feedItems = this.feedItems
            .slice(0, this.feedItems.length)
            .sort(function (f1, f2) {
            // need to sort, because we need to add post fetch by Id into correct position
            return (new Date(f2.createdAt).getTime() - new Date(f1.createdAt).getTime());
        });
    };
    FeedStore.prototype.addFeedItems = function (arr) {
        var merged = lodash_1.unionBy(arr, this.feedItems, 'feedItemId');
        this.feedItems = merged;
        this.sortFeedItems();
    };
    FeedStore.prototype.updateFeedItemsRepository = function () {
        var _this = this;
        this.feedItems.forEach(function (fI) { return fI.setRepository(_this.repository); });
    };
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.list(serializr_1.object(FeedItem_1.FeedItem))),
        mobx_1.observable.shallow
    ], FeedStore.prototype, "feedItems", void 0);
    tslib_1.__decorate([
        serializr_1.serializable,
        mobx_1.observable
    ], FeedStore.prototype, "loading", void 0);
    tslib_1.__decorate([
        serializr_1.serializable,
        mobx_1.observable
    ], FeedStore.prototype, "cursor", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "fetch", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "fetchMore", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FeedStore.prototype, "fetchById", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "create", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "update", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "delete", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "pin", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "unpin", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "follow", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "unfollow", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "react", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "unreact", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "addReaction", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "removeReaction", void 0);
    return FeedStore;
}());
exports.FeedStore = FeedStore;
//# sourceMappingURL=FeedStore.js.map